<template>
<tab>
    <section class="section games-page">
        <div class="games-page-bg">
            <s-img :class="{'current-bg': currentTab === 'vegas'}"
                src="/assets/img/games-page/bg-vegas.png" alt="bg"/>
            <s-img :class="{'current-bg': currentTab === 'macau'}"
                src="/assets/img/games-page/bg-macau.png" alt="bg"/>
        </div>
        <b-container>
            <div class="games-tabs">
                <client-only>
                    <component :is="component" :tabs="tabs" :currentTab="currentTab" :type="type"/>
                </client-only>
            </div>
        </b-container>
    </section>
</tab>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import tabContent from './tabs.vue';
// eslint-disable-next-line import/no-unresolved
import tab from '~/components/tab.vue';

export default {
    components: {
        tab,
        tabContent
    },
    props: ['tabs', 'tabIndex', 'currentTab', 'type'],
    data() {
        return {
            component: tabContent
        };
    }
};
</script>
